import MaterialLoader from "../../../output/assets/materials/material-loader.js";

class ThreePbrBasicMaterialLoader extends MaterialLoader {
    constructor() {
        super();
    }

    load() {
        return new THREE.MeshBasicMaterial();
    }

    unload(material) {
        material.dispose();
    }
}

export default ThreePbrBasicMaterialLoader;
